import { memo, useCallback, useMemo } from 'react';
import { getLiteral } from 'utils/getLiteral';
import AdvancedSelect from 'components/AdvancedSelect';
import SelectHoi from 'components/SelectHoi';
import { getDayWeekOptions } from '../../../../../../utils';

import './styles.scss';

const InputWeekDayOperatorForm = memo(
    ({ onChange, value = [], options, defaultFilter, filterOptions }) => {
        const innerOnChange = useCallback(
            (v, idx) => {
                let newValue = value || [];
                newValue[idx] = v;
                onChange(newValue);
            },
            [onChange, value],
        );

        const dayWeekOptions = useMemo(() => getDayWeekOptions(), []);

        return (
            <div>
                <SelectHoi
                    options={dayWeekOptions}
                    value={value[1]}
                    onChange={(v) => innerOnChange(v, 1)}
                    usePlainValue
                    isFullWidth
                    useMenuPortal={false}
                />
                <AdvancedSelect
                    searchPlaceholder={getLiteral('placeholder_search_field')}
                    menuTitle={getLiteral('cfm_action_add_field')}
                    placeholder={getLiteral('label_placeholder_field')}
                    value={value[0]}
                    onChange={(v) => innerOnChange(v, 0)}
                    options={options}
                    defaultFilter={defaultFilter}
                    filterOptions={filterOptions}
                    isFullWidth
                    useMenuPortal={false}
                />
            </div>
        );
    },
);

export default InputWeekDayOperatorForm;
